import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactHero } from '../components/contact/ContactHero';
import { ContactForm } from '../components/contact/ContactForm';
import { LocationContactSelector } from '../components/contact/LocationContactSelector';
import { CTASection } from '../components/home/CTASection';
export function ContactPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-729">
      <Header data-id="element-730" />

      <main className="pt-20" data-id="element-731">
        <ContactHero data-id="element-732" />
        <ContactForm data-id="element-733" />
        <LocationContactSelector data-id="element-734" />
        <CTASection data-id="element-735" />
      </main>

      <Footer data-id="element-736" />
    </div>;
}